<template>
	<a class="skip-link" href="#main">Skip to content</a>
	<div class="announcement">
		<span>PAYDECK INDIA</span><span class="announcement-divider" aria-hidden="true" /><span>MAKING EVERYDAY PAYMENTS POSSIBLE SINCE 2014</span>
	</div>
	<header class="site-header">
		<div class="header-inner">
			<Brand />
			<nav class="desktop-nav" aria-label="Main navigation">
				<router-link v-for="item in navItems" :key="item.href" :to="item.href">{{ item.label }}</router-link>
			</nav>
			<div class="account-actions" aria-label="Paydeck account">
				<a class="login-link" :href="loginUrl">Login</a>
				<PdButton size="sm" :href="registerUrl" :icon-right="ArrowUpRight">Register</PdButton>
			</div>
			<button class="menu-toggle" type="button" :aria-expanded="menuOpen" aria-controls="mobile-navigation" :aria-label="menuOpen ? 'Close menu' : 'Open menu'" @click="menuOpen = !menuOpen">
				<X v-if="menuOpen" :size="22" /><Menu v-else :size="22" />
			</button>
		</div>
		<nav id="mobile-navigation" :class="['mobile-nav', { open: menuOpen }]" aria-label="Mobile navigation">
			<router-link v-for="item in navItems" :key="item.href" :to="item.href" @click="menuOpen = false">{{ item.label }}<ArrowUpRight :size="18" /></router-link>
			<div class="mobile-account-actions">
				<PdButton variant="neutral" block :href="loginUrl">Login</PdButton>
				<PdButton block :href="registerUrl" :icon-right="ArrowUpRight">Register</PdButton>
			</div>
		</nav>
	</header>
</template>

<script setup>
import { ref } from "vue";
import { ArrowUpRight, Menu, X } from "lucide-vue-next";
import PdButton from "@paydeck-ui/components/PdButton.vue";
import Brand from "./Brand.vue";
import { navItems, loginUrl, registerUrl } from "@/content/site";

const menuOpen = ref(false);
</script>
